import styles from './GroupRow.scss';
import tableStyles from 'part11/components/GroupRow/GroupTable.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';

export default class GroupRow extends Component {
    render() {
        const { group } = this.props;
        if(lodash.isNil(group)) {
            return null;
        }

        return (
            <div className={styles.tableRowHorizontalWrapper + ' ' + styles.tableRowBorder} data-cy="GroupRow">
                <div className={styles.tableRowVerticalWrapper}>
                    <div className={styles.tableRowHorizontalWrapper}>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.text} title={group.displayName} data-cy="GroupRow-displayName">
                                { group.displayName }
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.text} title={group.description} data-cy="GroupRow-description">
                                { group.description }
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.searchable} data-cy="GroupRow-isSearchable">
                                { group.isSearchable ? 'Searchable' : 'Not searchable' }
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.dts}>
                                {
                                    Array.isArray(group.documentTypes)
                                        ? group.documentTypes.length
                                        : '0'
                                }
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.users} data-cy="GroupRow-tableStyles">
                                { Array.isArray(group.users) ? group.users.length : '0' }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

GroupRow.propTypes = {
    group: PropTypes.shape({
        displayName: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        documentTypes: PropTypes.arrayOf(PropTypes.shape({
            displayName: PropTypes.string.isRequired
        }))
    })
};
